import React, { useEffect, useState } from "react";
import useLangTranslation from "../../../customHooks/languageProvider";
import {
  addAppTime,
  getAllApps,
  setAllAppData,
} from "../../AxiosRtk/DashBoard";
import { Modal } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { setShowMessage } from "../../AxiosRtk/successMessage";
import useDurationOption from "../../../customHooks/durationOption";
import Select from "react-select";

const AddTimeLimit = ({
  showDeletedModal,
  closeDeletedModal,
  appId,
  allAppData,
  selectedKidId,
  deviceId,
  appEditModeData,
  appDelModeData,
  setEditModeData,
  setAppDelModeData,
}) => {

  const { daysAndWeekFunction } = useDurationOption();
  const daysAndWeekOptions = daysAndWeekFunction();
  const appData = allAppData?.find(
    (element) => parseInt(element?.ID) === parseInt(appId)
  );
  const [daySelect, setDaySelect] = useState("EVERYDAY");
  const [time, setTime] = useState({
    hours: 0,
    minutes: 0,
  });
  const [error, setError] = useState("");
  const { getLangTranslation } = useLangTranslation();
  const [apiHit, setApiHit] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    if (appEditModeData?.isEdit === 1) {
      setDaySelect(appEditModeData?.day?.toUpperCase());
      setTime({
        hours: appEditModeData?.hours,
        minutes: appEditModeData?.minutes,
      });
    }
  }, [appEditModeData]);

  function handleInputChange(e) {
    const { name, value } = e.target;
    if (
      name === "hours" &&
      parseInt(value) * 60 + parseInt(time?.minutes) > 1439
    ) {
      setError("YOU_CANNOT_ADD_TIME_LIMT_MORE_THAN_24_HR_TXT");
      return;
    } else if (
      name === "minutes" &&
      parseInt(time?.hours) * 60 + parseInt(time?.minutes) > 1439
    ) {
      setError("YOU_CANNOT_ADD_TIME_LIMT_MORE_THAN_24_HR_TXT");
      return;
    }

    if (name === "day-select") {
      setDaySelect(value);
    } else if (name === "hours") {
      if (value < 0 || value > 24) {
        return;
      }
      setTime({
        ...time,
        hours: value,
      });
      setError("");
    } else if (name === "minutes") {
      if (value < 0 || value > 59) {
        return;
      }
      setTime({
        ...time,
        minutes: value,
      });
      setError("");
    }
  }

  function handleAppTimeSave() {
    if (time?.hours === 0 && time?.minutes === 0) {
      setError("TIME_EXTENSION_SELECT_PAUSE_TIMEFRAME");
      return;
    }

    setApiHit(true);
    const totalMinutes = parseInt(time?.hours) * 60 + parseInt(time?.minutes);
    const dayLimit = {
      Monday: 0,
      Tuesday: 0,
      Wednesday: 0,
      Thursday: 0,
      Friday: 0,
      Saturday: 0,
      Sunday: 0,
    };

    if (daySelect === "WEEKDAYS") {
      dayLimit["Monday"] = totalMinutes;
      dayLimit["Tuesday"] = totalMinutes;
      dayLimit["Wednesday"] = totalMinutes;
      dayLimit["Thursday"] = totalMinutes;
      dayLimit["Friday"] = totalMinutes;
    } else if (daySelect === "WEEKEND") {
      dayLimit["Saturday"] = totalMinutes;
      dayLimit["Sunday"] = totalMinutes;
    } else if (daySelect === "MONDAY") {
      dayLimit["Monday"] = totalMinutes;
    } else if (daySelect === "TUESDAY") {
      dayLimit["Tuesday"] = totalMinutes;
    } else if (daySelect === "WEDNESDAY") {
      dayLimit["Wednesday"] = totalMinutes;
    } else if (daySelect === "THURSDAY") {
      dayLimit["Thursday"] = totalMinutes;
    } else if (daySelect === "FRIDAY") {
      dayLimit["Friday"] = totalMinutes;
    } else if (daySelect === "SATURDAY") {
      dayLimit["Saturday"] = totalMinutes;
    } else if (daySelect === "SUNDAY") {
      dayLimit["Sunday"] = totalMinutes;
    } else {
      dayLimit["Monday"] = totalMinutes;
      dayLimit["Tuesday"] = totalMinutes;
      dayLimit["Wednesday"] = totalMinutes;
      dayLimit["Thursday"] = totalMinutes;
      dayLimit["Friday"] = totalMinutes;
      dayLimit["Saturday"] = totalMinutes;
      dayLimit["Sunday"] = totalMinutes;
    }

    const payload = {
      DailyLimit: dayLimit,
      appPackageName: appData?.AppPackageName,
      deviceId: appData?.KidsDeviceId,
      isForAllApp: 0,
      is_load_default_settings: 0,
      kidId: appData?.KidId,
    };

    addAppTime(payload)
      .then((res) => {
        // setTimeout(() => {
        closeDeletedModal();
        // }, 1500);
        setTimeout(() => {
          dispatch(
            setShowMessage({
              showMessage: true,
              defaultMessage: res?.data?.message,
              message: res?.data?.message,
            })
          );
        }, 1200);

        getAllApps({
          kidId: selectedKidId,
          kidDeviceId: deviceId,
          pageOffset: 1,
          pageLimit: 500,
        })
          .then((res) => {
            dispatch(setAllAppData(res?.data?.result));
          })
          .catch((err) => {
            console.log(
              "get all apps catch error ==>>",
              err?.response?.data?.message
            );
          });
      })
      .catch((err) => {
        console.log(
          "adding app timing catch error ===>>>",
          err?.response?.data?.message
        );
      })
      .finally(() => {
        setApiHit(false);
        setTime({ hours: 0, minutes: 0 });
        setEditModeData({ isEdit: 0, day: "", hours: 0, minutes: 0 });
        setAppDelModeData({ isDel: 0, time: "" });
        setDaySelect("EVERYDAY");
      });
  }

  function handleAppTimeDelete() {
    setApiHit(true);
    const dayLimit = {
      Monday: 0,
      Tuesday: 0,
      Wednesday: 0,
      Thursday: 0,
      Friday: 0,
      Saturday: 0,
      Sunday: 0,
    };

    const payload = {
      DailyLimit: dayLimit,
      appPackageName: appData?.AppPackageName,
      deviceId: appData?.KidsDeviceId,
      isForAllApp: 0,
      is_load_default_settings: 0,
      kidId: appData?.KidId,
    };

    addAppTime(payload)
      .then((res) => {
        {
          /*  AlertModal("APP_TIME_DELETE_MSG", alertIconType?.successIcon);*/
        }
        dispatch(
          setShowMessage({
            showMessage: true,
            defaultMessage:
              "App daily time limit has been updated successfully",
            message: "APP_TIME_UPDATED",
          })
        );
      })
      .then(() => {
        getAllApps({
          kidId: selectedKidId,
          kidDeviceId: deviceId,
          pageOffset: 1,
          pageLimit: 500,
        })
          .then((res) => {
            dispatch(setAllAppData(res?.data?.result));
          })
          .catch((err) => {
            console.log(
              "get all apps catch error ==>>",
              err?.response?.data?.message
            );
          });
      })
      .then(() => {
        // setTimeout(() => {
        closeDeletedModal();
        // }, 1500);
      })
      .catch((err) => {
        console.log(
          "adding app timing catch error ===>>>",
          err?.response?.data?.message
        );
      })
      .finally(() => {
        setApiHit(false);
        setTime({ hours: 0, minutes: 0 });
        setEditModeData({ isEdit: 0, day: "", hours: 0, minutes: 0 });
        setAppDelModeData({ isDel: 0, time: "" });
        setDaySelect("EVERYDAY");
      });
  }

  const handleIncrementHours = () => {
    if (time?.hours < 23) {
      setTime({
        ...time,
        hours: parseInt(time?.hours) + 1
      })
    }
  };

  const handleDecrementHours = () => {
    if (time?.hours > 0) {
      setTime({
        ...time,
        hours: parseInt(time?.hours) - 1
      })
    }
  };

  const handleIncrementMinutes = () => {
    if (time?.minutes < 59) {
      setTime({
        ...time,
        minutes: parseInt(time?.minutes) + 1
      })
    }
  };

  const handleDecrementMinutes = () => {
    if (time?.minutes > 0) {
      setTime({
        ...time,
        minutes: parseInt(time?.minutes) - 1
      })
    }
  };
  // console.log(showDeletedModal)
  return (
    <Modal
      show={showDeletedModal}
      size="sm"
      className="custom-modal blur-bg"
      centered
    >
      <Modal.Header>
        <div className="border-0 pb-0 d-flex justify-content-between w-100">
          <h6 className="modal-title text-blue-900">
            {appDelModeData?.isDel === 1
              ? getLangTranslation("DELETE_TIME_LIMIT", "Delete time limit")
              : getLangTranslation("ADD_TIME_LIMIT", "Add time limit")}
          </h6>
          <button
            type="button"
            className="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
            onClick={closeDeletedModal}
          ></button>
        </div>
      </Modal.Header>
      <Modal.Body>
        <div className="">
          {appDelModeData?.isDel === 1 && (
            <div className="d-flex justify-content-between">
              <div className="d-inline-flex align-items-center text-dark mb-6">
                <span className="icon-wrap icon-sm me-2 p-0 border-0">
                  <img src={appData?.image} alt="" />
                </span>
                {appData?.app_name}
              </div>
              <div>{appDelModeData?.time}</div>
            </div>
          )}

          {appDelModeData?.isDel === 0 && (
            <div className="d-inline-flex align-items-center text-dark mb-6">
              <span className="icon-wrap icon-sm me-2 p-0 border-0">
                <img src={appData?.image} alt="" />
              </span>
              {appData?.app_name}
            </div>
          )}

          {appDelModeData?.isDel === 0 && (
            <>
              <Select
                className="custom-select"
                classNamePrefix="custom-select"
                placeholder="Select"
                onChange={(val) => {
                  setDaySelect(val.value);
                }}
                options={daysAndWeekOptions}
                value={
                  daysAndWeekOptions?.find(
                    (item) => item?.value == daySelect
                  ) || ""
                }
              />
              <label className="text-small text-gray text-uppercase my-3">
                {getLangTranslation("LOCK_DEVICE_CHOOSE_TIME", "Choose time")}
              </label>
              {/* <div className="grid gap-3 mb-2">
                <input
                  type="number"
                  className="form-control g-col-6"
                  placeholder="Hours"
                  name="hours"
                  value={time?.hours}
                  onChange={handleInputChange}
                />
                <input
                  type="number"
                  className="form-control g-col-6"
                  placeholder="Minutes"
                  name="minutes"
                  value={time?.minutes}
                  onChange={handleInputChange}
                />
              </div> */}
              <div className="d-flex gap-3">
                <div className="form-control-num">
                  <div className="position-relative">
                    <input
                      type="number"
                      className="form-control text-blue-900 fw-semibold"
                      // placeholder="hh"
                      name="hours"
                      value={time?.hours}
                      onChange={(e) => handleInputChange(e)}
                    />
                    <span
                      className="position-absolute top-50 text-blue-900 translate-middle-y"
                      style={{ left: "30px" }}
                    >
                      h
                    </span>
                  </div>

                  <div className="form-control-num-arrows blue-900">
                    <i
                      className="icon-arrow-left arrow-up"
                      onClick={() => handleIncrementHours()}
                    />
                    <i
                      className="icon-arrow-left arrow-down"
                      onClick={() => handleDecrementHours()}
                    />
                  </div>
                </div>
                <div className="form-control-num">
                  <div className="position-relative">
                    <input
                      type="number"
                      className="form-control text-blue-900 g-col-2 fw-semibold"
                      name="minutes"
                      // placeholder="mm"
                      value={time?.minutes}
                      onChange={(e) => handleInputChange(e)}
                    />
                    <span
                      className="position-absolute top-50 text-blue-900 translate-middle-y"
                      style={{ left: "30px" }}
                    >
                      m
                    </span>
                  </div>
                  <div className="form-control-num-arrows blue-900">
                    <i
                      className="icon-arrow-left arrow-up"
                      onClick={handleIncrementMinutes}
                    />
                    <i
                      className="icon-arrow-left arrow-down"
                      onClick={handleDecrementMinutes}
                    />
                  </div>
                </div>
              </div>
            </>
          )}
          {error && (
            <div>
              <span className="text-danger" style={{ fontSize: "12px" }}>
                {getLangTranslation(error)}
              </span>
            </div>
          )}
          <button
            className="btn btn-primary w-100 my-3"
            type="button"
            data-bs-dismiss="modal"
            aria-label="Close"
            // onClick={closeDeletedModal}
            disabled={apiHit}
            onClick={
              appDelModeData?.isDel === 1
                ? handleAppTimeDelete
                : handleAppTimeSave
            }
          >
            <span className="btn-upper-case">
              {appDelModeData?.isDel === 0
                ? getLangTranslation("SAVE", "Save")
                : getLangTranslation("DELETE", "Delete")}
            </span>
          </button>
          <button
            className="btn btn-outline-primary w-100"
            type="button"
            data-bs-dismiss="modal"
            aria-label="Close"
            onClick={closeDeletedModal}
            disabled={apiHit}
          >
            <span className="btn-upper-case">
              {getLangTranslation("CANCEL", "Cancel")}
            </span>
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default AddTimeLimit;
